import loadLogin            from 'bundle-loader?lazy&name=login!./components/routes/login';
import loadLaunchAs         from 'bundle-loader?lazy&name=launch-as!./components/routes/launch-as';
import loadActivityHistory  from 'bundle-loader?lazy&name=activity-history!./components/routes/activity-history';
import loadActivation       from 'bundle-loader?lazy&name=activation!./components/routes/activation';
import loadForgotPassword   from 'bundle-loader?lazy&name=forgot-password!./components/routes/forgot-password';
import loadForgotUserId     from 'bundle-loader?lazy&name=forgot-user-id!./components/routes/forgot-user-id';
import loadHome             from 'bundle-loader?lazy&name=home!./components/routes/home';
import loadProfile          from 'bundle-loader?lazy&name=profile!./components/routes/profile';
import loadResetPassword    from 'bundle-loader?lazy&name=reset-password!./components/routes/reset-password';
import loadContact          from 'bundle-loader?lazy&name=contact!./components/routes/contact';
import loadRules            from 'bundle-loader?lazy&name=rules!./components/routes/rules';
import loadPrivacyShield    from 'bundle-loader?lazy&name=privacy-shield!./components/routes/privacy-shield/privacy-shield.jsx';
import loadPrivacyNotice    from 'bundle-loader?lazy&name=privacy-notice!./components/routes/privacy-notice/privacy-notice.jsx';
import loadFaqs             from 'bundle-loader?lazy&name=faqs!./components/routes/faqs';
import loadSSOAuthenticated from 'bundle-loader?lazy&name=sso-authenticated!./components/routes/sso-authenticated';
import loadSSOLogout        from 'bundle-loader?lazy&name=sso-logout!./components/routes/sso-logout';
import loadSSOError         from 'bundle-loader?lazy&name=error!./components/routes/sso-error/sso-error.jsx';
import loadError            from 'bundle-loader?lazy&name=error!./components/routes/error';


export default [ {
    name: 'Activation',
    path: '/activation',
    onLoad: loadActivation,
    preLoadPriority: 3,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'Login',
    path: '/login',
    onLoad: loadLogin,
    preLoadPriority: 1,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'Launch As',
    path: '/launch-as',
    onLoad: loadLaunchAs,
    preLoadPriority: 13,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'Forgot User Id',
    path: '/forgot-user-id',
    onLoad: loadForgotUserId,
    preLoadPriority: 5,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'Forgot Password',
    path: '/forgot-password',
    onLoad: loadForgotPassword,
    preLoadPriority: 6,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    path: '/reset-password',
    onLoad: loadResetPassword,
    preLoadPriority: 12,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'SSO Authenticated',
    path: '/sso-authenticated',
    onLoad: loadSSOAuthenticated,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'SSO Logout',
    path: '/sso-logout',
    onLoad: loadSSOLogout,
    allowAnonymous: true,
    allowAuthenticated: false
}, {
    name: 'Home',
    path: '/home',
    onLoad: loadHome,
    preLoadPriority: 2,
    allowAnonymous: false,
    allowAuthenticated: true
}, {
    path: '/',
    onLoad: loadHome,
    preLoadPriority: 2,
    allowAnonymous: false,
    allowAuthenticated: true,
    default: true
}, {
    name: 'Profile',
    path: '/profile',
    onLoad: loadProfile,
    preLoadPriority: 4,
    allowAnonymous: false,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Rules',
    path: '/rules',
    onLoad: loadRules,
    preLoadPriority: 8,
    allowAnonymous: false,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Contact',
    path: '/contact',
    onLoad: loadContact,
    preLoadPriority: 11,
    allowAnonymous: false,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Activity History',
    path: '/activity-history',
    onLoad: loadActivityHistory,
    preLoadPriority: 7,
    allowAnonymous: false,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'FAQs',
    path: '/faqs',
    onLoad: loadFaqs,
    preLoadPriority: 10,
    allowAnonymous: true,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Privacy Shield',
    path: '/privacy-shield',
    onLoad: loadPrivacyShield,
    preLoadPriority: 9,
    allowAnonymous: true,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Privacy Notice',
    path: '/privacy-notice',
    onLoad: loadPrivacyNotice,
    preLoadPriority: 9,
    allowAnonymous: false,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Error',
    path: '/error',
    onLoad: loadError,
    preLoadPriority: 9,
    allowAnonymous: true,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Error',
    path: '/ssoGatewayLogonFailure',
    onLoad: loadSSOError,
    preLoadPriority: 9,
    allowAnonymous: true,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Error',
    path: '/ssoLogonFailure',
    onLoad: loadSSOError,
    preLoadPriority: 9,
    allowAnonymous: true,
    allowAuthenticated: true,
    modal: true
}, {
    name: 'Error',
    path: '/ssoFailure',
    onLoad: loadSSOError,
    preLoadPriority: 9,
    allowAnonymous: true,
    allowAuthenticated: true,
    modal: true
} ];
